module.exports = __webpack_public_path__ + "img/banner-1.e7f68a9a.webp";